export default __webpack_public_path__ + "static/media/email.e2fc008e.svg";